import { HTMLAttributes } from 'react'
import clsx from 'clsx'
import Link, { LinkProps } from 'next/link'

import { ButtonSizes, ButtonVariants } from 'shared/ui/Button/Button.enums'

import styles from './LinkButton.module.scss'

export interface LinkButtonProps
  extends LinkProps,
    HTMLAttributes<HTMLAnchorElement> {
  children?: React.ReactNode
  variant?: ButtonVariants
  size?: ButtonSizes
  disabled?: boolean
  startIcon?: React.ReactElement
  endIcon?: React.ReactElement
  fullWidth?: boolean
  download?: string
  active?: boolean
}

const LinkButton = ({
  fullWidth,
  children,
  variant = ButtonVariants.primary,
  size = ButtonSizes.medium,
  disabled,
  startIcon,
  endIcon,
  href,
  download,
  active = false,
  className,
  ...props
}: LinkButtonProps) => {
  const classNames = (isAnchor: boolean) =>
    clsx(
      styles.linkButton,
      styles[variant] ?? styles.primary,
      {
        [styles.fullWidth]: fullWidth,
        [styles.disabled]: disabled,
        [styles.active]: active,
        [styles.anchor]: isAnchor
      },
      className
    )

  return download ? (
    <a
      href={href as string}
      data-size={size as string}
      download={download}
      {...props}
      className={classNames(true)}
    >
      {startIcon && <div className={styles.iconContainer}>{startIcon}</div>}
      {children}
      {endIcon && <div className={styles.iconContainer}>{endIcon}</div>}
    </a>
  ) : (
    <Link
      href={href}
      data-size={size as string}
      download={download}
      {...props}
      className={classNames(false)}
    >
      {startIcon && <div className={styles.iconContainer}>{startIcon}</div>}
      {children}
      {endIcon && <div className={styles.iconContainer}>{endIcon}</div>}
    </Link>
  )
}

export default LinkButton
